module.exports = __webpack_public_path__ + "img/merchant-page-graphic1@4x.3df5359f.png";